<div class="form-wrapper">
    <router-outlet></router-outlet>
</div>
